import { GameId } from '@bg-shared/enums/GameId';
import { CasinoChipsService } from './CasinoChips.service';
import { CasinoValidationService } from './CasinoValidation.service';
import { CasinoBettingApi } from './CasinoBetting.api';
import { ICasinoSettings } from '../ICasinoSettings';

export class CasinoServiceFactory {
    private static chips = new Map<GameId, CasinoChipsService>();

    private static validations = new Map<GameId, CasinoValidationService>();

    private static api = new Map<GameId, CasinoBettingApi>();

    private static getService<T>(map: Map<GameId, T>, creator: () => T, id: GameId): T {
        if (!map.has(id)) {
            map.set(id, creator());
        }

        return map.get(id);
    }

    public static createServices(settings: ICasinoSettings) {
        const apiService = this.getService(
            this.api,
            settings.apiServiceFactory ||
                (() => new CasinoBettingApi(settings.gameId, settings.gameWithSwitchView)),
            settings.gameId,
        );
        const validationService = this.getService(
            this.validations,
            settings.validationServiceFactory ||
                (() => new CasinoValidationService(settings.gameId)),
            settings.gameId,
        );
        const chipsService = this.getService(
            this.chips,
            settings.chipsServiceFactory ||
                (() => new CasinoChipsService(settings.gameId, validationService, apiService)),
            settings.gameId,
        );

        return {
            apiService,
            chipsService,
            validationService,
        };
    }

    public static getChips(gameId: GameId): CasinoChipsService {
        return this.chips.get(gameId);
    }

    public static getValidation(gameId: GameId): CasinoValidationService {
        return this.validations.get(gameId);
    }

    public static getAPI(gameId: GameId): CasinoBettingApi {
        return this.api.get(gameId);
    }
}
